import type { PartSvgProps } from './types'

export default function SlingMountSvg ({
  fill = 'var(--gs-part-fill,   #2A2A3A)',
  stroke = 'var(--gs-part-stroke, #5A6A7A)',
  accent = 'var(--gs-part-accent, #E85D04)',
  width = 60,
  height = 60
}: PartSvgProps) {
  return (
    <svg viewBox="0 0 60 60" width={width} height={height} fill="none"
         xmlns="http://www.w3.org/2000/svg">
      {/* Outer QD ring */}
      <circle cx="30" cy="30" r="24"
              fill={fill} stroke={stroke} strokeWidth="2" />
      {/* Inner swivel loop */}
      <circle cx="30" cy="30" r="14"
              fill="none" stroke={accent} strokeWidth="1.5" />
      {/* Lever detail (across diameter) */}
      <path d="M 16 30 L 22 22 L 38 22 L 44 30" fill="none" stroke={stroke} strokeWidth="1.2" />
      {/* Center pin */}
      <circle cx="30" cy="30" r="4"
              fill={fill} stroke={stroke} strokeWidth="1" />
    </svg>
  )
}
